import { jsxs, jsx } from "../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.js";
import { memo } from "react";
import { DualGridCardLayoutElement } from "./core/card-element.es.js";
import { DualGridCardLayourWrapper } from "./components/card-wrapper.es.js";
function generateDualGridCardLayout({
  startElement,
  endElement,
  maxWidth,
  ...rest
}) {
  return /* @__PURE__ */ jsxs(DualGridCardLayourWrapper, { maxWidth, ...rest, children: [
    /* @__PURE__ */ jsx(DualGridCardLayoutElement, { ...startElement }),
    /* @__PURE__ */ jsx(DualGridCardLayoutElement, { ...endElement })
  ] });
}
const DualGridCardLayout = memo(generateDualGridCardLayout);
export {
  DualGridCardLayout
};
//# sourceMappingURL=dual-grid-card-layout.es.js.map
